<div class="marketplace-orders-modal-container d-flex flex-column" style="height:564px">
    <div class="modal-header my-1">
        <h8 class="modal-title lato-bold" cvLocalizedText langSection="Command_Center" langKey="Marketplace_Products">Marketplace Products</h8>
        <button id="closeProductsModalBtn" type="button" class="ml-auto close" aria-label="Close" (click)="closeModal()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body flex-fill pt-0">
        <ag-grid-angular *ngIf="gridProducts" class="ag-theme-material lato-regular h-100 w-100 overflow-auto" [gridOptions]="gridProducts"></ag-grid-angular>
    </div>
</div>